import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { ROUTES } from '../routes'
import { useReaderLogStore } from '@/modules/FindControllerLog/store'

export const useReaderNavigation = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { source, clearSource } = useReaderLogStore()

    const backCallback = useMemo(() => {
        if (!source) {
            return null
        }

        if (source && location.pathname === ROUTES.HOME) {
            return () => clearSource()
        }

        if ([ROUTES.VEHICLE_ALLOCATION, ROUTES.DISRUPTIONS, ROUTES.SHARED_LOG].includes(location.pathname)) {
            return () => navigate(ROUTES.HOME)
        }
    }, [location, source, clearSource])

    const paths = useMemo(() => {
        if (source && [ROUTES.HOME, ROUTES.SHARED_LOG].includes(location.pathname)) {
            return ['Controller logs', source.title]
        }

        if (source && location.pathname === ROUTES.VEHICLE_ALLOCATION) {
            return [source.title, 'Vehicle allocation']
        }

        if (source && ROUTES.DISRUPTIONS === location.pathname) {
            return [source.title, 'Disruptions']
        }

        return []
    }, [source, location])

    return {
        backCallback,
        paths,
    }
}
